import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface AddTemplateState {
  value: object;
}

const initialState: AddTemplateState = {
  value: {},
};

export const AddTemplateSlice = createSlice({
  name: "addtemplate",
  initialState,
  reducers: {
  
    addTemplateValue: (
      state: AddTemplateState,
      action: PayloadAction<object>
    ) => {
      state.value = action.payload;
    },
  },
});

export const { addTemplateValue } = AddTemplateSlice.actions;

export default AddTemplateSlice.reducer;
